// extracted by mini-css-extract-plugin
export var csatScore = "_hc-5";
export var header = "_hc-1";
export var panelWrapper = "_hc-2";
export var postPreview = "_hc-3";
export var rightContent = "_hc-0";
export var wrappingText = "_hc-4";